export default "__VITE_ASSET__DE733NlL__"